export const moreAboutMeInitialState = {
  impactOn: '',
  impactInterested: '',
  impactGoodAt: '',
  mostProductiveInspired: '',
  whenHaveYouFailed: '',
  inDealingWithPeople: '',
  toGetMeTalking: ''
}

export type MoreAboutMeState = typeof moreAboutMeInitialState
